import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import Root, { pageKindFromPath } from './Root';

const container = document.getElementById('root');
const page = pageKindFromPath(window.location.pathname);
hydrateRoot(container, <React.StrictMode><Root page={page} /></React.StrictMode>);
